export default ()=>{
  return new Promise( (resolve, reject) => {
  	//import store from 'ks_app/store'
  	let a = "william";
    if('william' == a){
        resolve(true);
    }
    reject({path:"/login"});
  })
}